import { IPaymentMethod, IServiceTypes } from "../../../model/ahamove/FormTemplate"

export enum PaymentMethodEnum {
  CASH = 'CASH',
  CASH_BY_RECIPIENT = 'CASH_BY_RECIPIENT',
  BALANCE = 'BALANCE'
}

export const PAYMENT_METHOD_DATA: IPaymentMethod[] = [
  {
    description: 'Cash',
    description_vi_vn: 'tiền mặt do người gửi trả',
    payment: PaymentMethodEnum.CASH,
    order: 1
  },
  {
    description: 'Cash By Recipient',
    description_vi_vn: 'tiền mặt do người nhận trả',
    payment: PaymentMethodEnum.CASH_BY_RECIPIENT,
    order: 2
  },
  {
    description: 'Balance',
    description_vi_vn: 'thanh toán từ tài khoản',
    payment: PaymentMethodEnum.BALANCE,
    order: 3
  }
]


export const SERVICE_TYPES_DATA: IServiceTypes[] = [
  {
    _id: 'VNM-TRUCK-B2B',
    name_vi_vn: 'Tuyến lấy hàng từ Hưng Yên',
    name: 'Hưng Yên - Hà Nội'
  }
]